/**
 * The login token is the same cookie the editor uses (`token`, path /), so signing in on the
 * website signs in to the editor and the other way round.
 */
const COOKIE = 'token';
const DAYS = 30;

export function getToken() {
  const match = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(`${COOKIE}=`));
  if (!match) return null;
  const value = decodeURIComponent(match.slice(COOKIE.length + 1));
  return value || null;
}

export function saveToken(token) {
  const expires = new Date(Date.now() + DAYS * 24 * 60 * 60 * 1000).toUTCString();
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${COOKIE}=${encodeURIComponent(token)};expires=${expires};Path=/;SameSite=Lax${secure}`;
}

export function clearToken() {
  document.cookie = `${COOKIE}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;Path=/`;
}

/** The token's payload. The browser cannot check the signature; the API does that on every call. */
export function decodeToken(token) {
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = part + '='.repeat((4 - (part.length % 4)) % 4);
    const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
}

/** The signed-in user, or null. An expired token counts as signed out. */
export function currentUser(token = getToken()) {
  if (!token) return null;
  const payload = decodeToken(token);
  if (!payload || !payload._id) return null;
  if (payload.exp && payload.exp * 1000 <= Date.now()) return null;
  return {
    id: payload._id,
    name: payload.full_name || payload.user_name || 'Your profile',
    isAdmin: (payload.permissionGroups || []).includes('ADMIN'),
  };
}

export function initials(name = '') {
  const words = String(name).trim().split(/\s+/).filter(Boolean);
  return words.slice(0, 2).map((word) => word[0].toUpperCase()).join('') || '?';
}
